import TemplatePanel from '../../templates/TemplatePanel';
import CustomerSideMenu from '../../organisms/side-menu/CustomerSideMenu';
import {routes} from '../../../app/router/routes';
import Breadcrumbs from '../../organisms/breadcrumbs/Breadcrumbs';
import React from 'react';
import MyAccountInfo from '../../organisms/forms/MyAccountInfo';
import ViewChangePassword from '../app-public/auth/ViewChangePassword';

const ViewCustomerData = () => {
    const bc = [{label: 'Moje konto', url: routes.customerData}];

    return (
        <TemplatePanel
            title={"Dane"}
            sideMenuRenderer={() => <CustomerSideMenu/>}
            breadcrumbsRenderer={() => <Breadcrumbs homeRoute={routes.customerData} settings={bc}/>}
        >
            <div className='flex flex-col lg:flex-row gap-6 mt-4 items-stretch lg:items-start '>
            <MyAccountInfo/>
            <ViewChangePassword/>
            </div>
        </TemplatePanel>
    );
};

export default ViewCustomerData;
